module.exports = __webpack_public_path__ + "img/applepay.d8756e43.svg";